(function($) {

  $(document).ready(function() {

    $(window).bind("load resize", function() {

      var width = $(window).width();
      
      if (width <= 991) {
        $('.gallery-nav a.is-checked').parent().addClass('list-toggler');
        $('.gallery-nav li').not('.list-toggler').hide();
      }
      else {
        $('.gallery-nav a.is-checked').parent().removeClass('list-toggler');
        $('.gallery-nav li').show();
      }

    });

    $('.gallery-nav').on('click', ".list-toggler a", function(e) {
      e.preventDefault();
      var toggleList = $(this).closest('.nav').find('li');
      toggleList.not('.list-toggler').toggle(300); 
    }); 


    var body = $('body');
    var closeSide = $('.att-close-side');
    var atMobileNav = $('.att-main-menu');

    // Mobile nav
    $('.mobile-nav-toggler').click(function(e){
      if (isOpenedNav()) {
        closeWidgetNav();
      } else {
        openWidgetNav();
      }
    });

    $('.att-main-menu .att-mobile-nav-close .close-side-widget').click(function(e){
      e.preventDefault();
      closeWidgetNav();
    });

    var isOpenedNav = function () {
      return atMobileNav.hasClass('mobile-nav-active');
    };

    var closeWidgetNav = function () {
      atMobileNav.removeClass('mobile-nav-active');
      closeSide.removeClass('att-close-side-opened');
      $('.hero-slider').css({'z-index':'inherit'});
      $('.site-header').css({'z-index':'10'});
    };

    var openWidgetNav = function () {
      atMobileNav.addClass('mobile-nav-active');
      closeSide.addClass('att-close-side-opened');
      $('.hero-slider').css({'z-index':'-1'});
      $('.site-header').css({'z-index':'inherit'});
    };

    // Close side
    body.on("click touchstart", ".att-close-side", function () {
      if ( isOpenedNav() ) {
        closeWidgetNav();
      } 
    });

    // Mobile nav arrow
    $('.navbar .nav li.drop-down').each(function(){
      $(this).append('<span class="dropdown-toggler-icon"></span>');
    });

    $('.att-main-menu').on("click", ".dropdown-toggler-icon", function (e) {
      e.preventDefault();

      if ($(this).parent().hasClass("children-open")) {
        $(this).parent().removeClass("children-open").find("> ul").slideUp(200);
      } else {
        $(this).parent().addClass("children-open").find("> ul").slideDown(200);
      }
    });

    // Hero slider
    if ( $( '.hero-slider .slider' ).length ) {

      $('.hero-slider .slider').slick({
        dots: false,
        prevArrow: $('.heroslider-arrows .prev-arrow'),
        nextArrow: $('.heroslider-arrows .next-arrow'),
      });
 
    }

    // Loga partneru slider
    if ( $( '.partners-logos .slider' ).length ) {
 
      $('.partners-logos .slider').slick({
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: $('.partners-arrows .prev-arrow'),
        nextArrow: $('.partners-arrows .next-arrow'),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      });
 
    }

    testScroll();

  });

  $(window).scroll(testScroll);
  var viewed = false;

  function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  function testScroll() {
    if (isScrolledIntoView($(".count-animation")) && !viewed) {
        viewed = true;
        $('.value').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 2000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
      });
    }
  }

})( jQuery );